import Cookies from 'js-cookie';
import {useState, useEffect} from 'react';
import {get} from '../helpers/fetch.js';

export default function Login ({setToken}) {

    const [username, setUsername] = useState(Cookies.get('username'));
    const [password, setPassword] = useState(Cookies.get('password'));

    function autoLogin () {
      if (username && password) {
        login();
      }
    }
    useEffect (autoLogin, []);

    async function login () {
      let res = await get('/user/auth?username=' + username + '&password=' + password);
      if (res.token) {
        let options = {expires:365};
        if (window.location.href.includes('aptuslogic')) { //ega does this line work in electron?
          options.domain = 'toto.aptuslogic.com';
        }
        Cookies.set('username', username, options);
        Cookies.set('password', password, options);
        setToken(res.token);
      }
    }
  
    return (
        <table style={{backgroundColor:'white'}}><tbody>
          <tr style={{fontSize:'18pt'}}>
            <td>Username:</td>
            <td><input type="text" value={username} onChange={e => setUsername(e.target.value)} /></td>
          </tr>
          <tr style={{fontSize:'18pt'}}>
            <td>Password:</td>
            <td><input type="password" value={password} onChange={e => setPassword(e.target.value)} /></td>
          </tr>
          <tr><td colSpan="2" style={{textAlign:'center'}}><input onClick={login} type="submit" value="Ok" style={{width:'100%'}} /></td></tr>
        </tbody></table>
    );
  }